import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { pageRoutes } from "../routes/PageRoutes";
import { useNavigate } from "react-router-dom";
import SubHeader from "../components/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { fetchMaintenance } from "../redux/actions/servicePresetsActions";
import { pipViewDate } from "../auth/Pip";
import ReactPagination from "../layout/ReactPagination";
import PaginationDropdown from "../layout/PaginationDropdown";
import Loader from "../components/Loader";

const Quotes = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isToggle, setIsToggle] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("All");

  const { maintananceList, isLoading } = useSelector(
    (state) => state?.servicePresetsReducer || {}
  );

  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  useEffect(() => {
    dispatch(fetchMaintenance());
  }, [dispatch]);

  // Filter quotes based on search and selected status
  const filteredQuotes = (maintananceList || []).filter((item) => {
    const matchesSearch =
      (item.ownerName || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.boatName || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.rego || "").toLowerCase().includes(searchTerm.toLowerCase());

    if (selectedStatus === "All") return matchesSearch;
    if (selectedStatus === "Approved") return matchesSearch && item.status === "APPROVED";
    if (selectedStatus === "Pending") return matchesSearch && item.status === "PENDING";
    if (selectedStatus === "Rejected") return matchesSearch && item.status === "REJECTED";
    return matchesSearch;
  });

  const displayQuotes = filteredQuotes.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage
  );

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle === false && "ct_active"}`}>
        <Sidebar path="customer-requests" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div className="ct_px_23 ct_mt_30 pb-5">
            <div className="ct_mb_30">
              <SubHeader />
            </div>
            
            <div className="">
              <div className="d-flex justify-content-end align-items-center ct_flex_col_575 gap-sm-5 gap-4 ct_mb_32 w-100">
                <div className="search-box ">
                  <div className="input-group position-relative">
                    <input
                      className="form-control ct_input ct_input_ps_40 ct_transparent_input"
                      type="text"
                      placeholder="Search by name, owner, rego"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                    />
                    <i className="fas fa-search ct_show_search"></i>
                  </div>
                </div>

                <div className="dropdown ct_w_100_575 d-flex">
                  <button
                    style={{ backgroundColor: "#fff" }}
                    className="btn filter-dropdown flex-grow-1 ct_w_100_575 d-flex align-items-center gap-4 justify-content-between text-nowrap"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {selectedStatus === "All" ? "All Status" : selectedStatus}
                    <i className="fa-solid fa-angle-down"></i>
                  </button>

                  <ul className="dropdown-menu ct_custom_dropdown_filter">
                    <li className="ct_pointer" onClick={() => { setSelectedStatus("All"); setCurrentPage(0); }}>
                      <a className="dropdown-item">All Status</a>
                    </li>
                    <li className="ct_pointer" onClick={() => { setSelectedStatus("Approved"); setCurrentPage(0); }}>
                      <a className="dropdown-item">Approved</a>
                    </li>
                    <li className="ct_pointer" onClick={() => { setSelectedStatus("Pending"); setCurrentPage(0); }}>
                      <a className="dropdown-item">Pending</a>
                    </li>
                    <li className="ct_pointer" onClick={() => { setSelectedStatus("Rejected"); setCurrentPage(0); }}>
                      <a className="dropdown-item">Rejected</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="ct_white_bg p-4 ct_border_radius_12 ct_mt_30">
                <div className="custom_table_wrapper">
                  <div className="table-responsive ct_custom_table">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Customer</th>
                          <th>Boat Name / Rego</th>
                          <th>Total cost</th>
                          <th>Estimated Duration</th>
                          <th>Date Sent</th>
                          <th>Status</th>
                          <th className="text-end">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayQuotes.length > 0 ? (
                          displayQuotes.map((item, i) => (
                            <tr key={item.taskId}>
                              <td className="ct_text_para">
                                {currentPage * usersPerPage + i + 1}
                              </td>
                              <td className="ct_text_para ct_fw_600">
                                {item.ownerName || "-"}
                              </td>
                              <td className="ct_text_para">
                                {item.boatName || "-"} <span className="text-muted">({item.rego || "-"})</span>
                              </td>
                              <td className="ct_text_para ct_fw_600">
                                ${Number(item.totalCost || 0).toFixed(2)}
                              </td>
                              <td className="ct_text_para">
                                {item.time_alloted || "0"} Hrs
                              </td>
                              <td className="ct_text_para">
                                {item.dateSent ? pipViewDate(item.dateSent) : "-"}
                              </td>
                              <td>
                                <div className="d-flex align-items-center gap-3">
                                  {item.status === "APPROVED" && (
                                    <>
                                      <span className="active-dot"></span>
                                      <span className="ct_active_badge">Accepted</span>
                                    </>
                                  )}
                                  {item.status === "PENDING" && (
                                    <>
                                      <span className="pending-dot"></span>
                                      <span className="ct_pending_badge">Pending</span>
                                    </>
                                  )}
                                  {item.status === "REJECTED" && (
                                    <>
                                      <span className="inactive-dot"></span>
                                      <span className="ct_inactive_badge" style={{ color: "#ef4444", backgroundColor: "#fef2f2" }}>Rejected</span>
                                    </>
                                  )}
                                </div>
                              </td>
                              <td className="text-end">
                                <a
                                  href="javascript:void(0)"
                                  onClick={() => {
                                    navigate(pageRoutes.QuotesDetail, {
                                      state: { taskId: item.taskId }
                                    });
                                  }}
                                >
                                  <svg
                                    width={22}
                                    height={15}
                                    viewBox="0 0 22 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10.8787 0.789062C17.7816 0.789062 20.9684 7.16109 20.9684 7.16109C20.9684 7.16109 17.7816 13.5331 10.8787 13.5331C3.97585 13.5331 0.789062 7.16109 0.789062 7.16109C0.789062 7.16109 3.97585 0.789062 10.8787 0.789062Z"
                                      stroke="#23C0E8"
                                      strokeWidth="1.57885"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M13.8901 7.16109C13.8994 7.57452 13.8259 7.98563 13.6741 8.37028C13.5223 8.75494 13.2951 9.10539 13.006 9.40105C12.7169 9.69671 12.3716 9.93163 11.9905 10.092C11.6093 10.2524 11.1999 10.335 10.7864 10.335C10.3729 10.335 9.96349 10.2524 9.58233 10.092C9.20116 9.93163 8.85588 9.69671 8.56676 9.40105C8.27763 9.10539 8.05049 8.75494 7.89867 8.37028C7.74685 7.98563 7.6734 7.57452 7.68265 7.16109C7.68265 6.33772 8.00973 5.54807 8.59194 4.96586C9.17415 4.38365 9.9638 4.05657 10.7872 4.05657C11.6105 4.05657 12.4002 4.38365 12.9824 4.96586C13.5646 5.54807 13.8917 6.33772 13.8917 7.16109H13.8901Z"
                                      stroke="#23C0E8"
                                      strokeWidth="1.57885"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </a>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center py-4 text-muted">
                              No quotes found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                {filteredQuotes.length > usersPerPage && (
                  <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mb-3">
                    <PaginationDropdown
                      onChange={(val) => {
                        setUserPerPages(val);
                        setCurrentPage(0);
                      }}
                    />
                    <ReactPagination
                      pageCount={Math.ceil(filteredQuotes.length / usersPerPage)}
                      onPageChange={handlePageClick}
                      currentPage={currentPage}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quotes;
